import color from "../../../constants/color";

const styles = {
  container: {
    width: "100%",
  },
  headerContainer: {
    pt: "10px",
    m: "16px",
    width: "100%",
  },
  title: {
    fontSize: "20px",
    fontWeight: "600",
    color: color.text,
  },
  section: {
    m: "16px",
    backgroundColor: color.card,
    px: "20px",
    py: "30px",
    borderRadius: "20px",
    mt: 0,
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    mb: 3,
  },
  headerLine: {
    border: "1.5px solid #28AA4A",
    width: "20px",
    marginRight: "8px",
  },
  subheadingBox: {
    mt: 3,
    width: "fit-content",
  },
  customHeading: {
    fontSize: "14px",
    fontWeight: "500",
    color: color.primary,
  },
  line: {
    borderBottom: "1px solid #28AA4A",
    mt: 2,
  },
  sectionGrid: {
    display: "flex",
    alignItems: "end",
    justifyContent: "space-between",
    mt: 3,
  },
  permissionLine: {
    border: "1.5px solid #28AA4A",
    width: "20px",
    mr: 1,
  },
  lineTextGrid: {
    display: "flex",
    alignItems: "center",
  },
  headerLineOld: {
    width: "4px",
    height: "24px",
    backgroundColor: color.primary,
    borderRadius: "2px",
  },
  sectionTitle: {
    fontSize: "14px",
    fontWeight: "500",
    color: color.text,
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      "& fieldset": {
        borderColor: "#DDDDDD",
      },
      "&:hover fieldset": {
        borderColor: color.text,
      },
      "&.Mui-focused fieldset": {
        borderColor: color.primary,
      },
      "&.Mui-error fieldset": {
        borderColor: "#d32f2f",
      },
    },
    "& .MuiInputBase-input": {
      fontSize: "14px",
    },
    "& .MuiFormHelperText-root": {
      fontSize: "12px",
    },
  },
  autoComplete: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      "& fieldset": {
        borderColor: "#DDDDDD",
      },
      "&:hover fieldset": {
        borderColor: color.text,
      },
      "&.Mui-focused fieldset": {
        borderColor: color.primary,
      },
      "&.Mui-error fieldset": {
        borderColor: "#d32f2f",
      },
    },
    "& .MuiInputBase-input": {
      fontSize: "14px",
    },
  },
  label: {
    fontSize: "14px",
    fontWeight: 500,
    color: color.text,
    mb: 1,
    display: "block",
  },
  errorText: {
    fontSize: "12px",
    color: "#d32f2f",
    mt: 0.5,
  },
  formGrid: {
    mb: 4,
  },
};

export default styles;
